<template>
  <div id="tulasi_game_view" class="tulasi_game_view_loading">
    Loading...
  </div>
</template>

<script>
// Launches a Tulasi Game merchant-platform game. Following this app's existing convention
// for third-party games (see components/game_list.vue's play() method), this navigates the
// whole page to the game URL rather than embedding it in an iframe — the platform's own
// custom URL schemes (tulasigame://exit, tulasigame://recharge) can only be intercepted by
// a native Android/iOS WebView wrapping this page (via shouldOverrideUrlLoading /
// WKNavigationDelegate), which lives outside this repo. A plain mobile browser tab, and this
// Vue app's own JS context, have no way to observe or react to those custom-scheme navigation
// attempts once we've navigated away — there is no in-page JS left running to catch them.
// This component only builds the URL and performs the navigation; scheme interception must
// be implemented in the native shell that hosts this page, if/when one exists.
export default {
  created() {
    const url = this.buildGameUrl()
    if (url) {
      window.location.href = url
    }
  },
  methods: {
    buildGameUrl() {
      const q = this.$route.query
      const gameDomain = q.gameDomain
      const slug = q.slug
      const merchantId = q.merchantId
      const gameId = q.gameId
      const roomId = q.roomId || '111'
      const token = q.token
      const lang = q.lang || 'en'

      if (!gameDomain || !slug || !merchantId || !gameId || !token) {
        console.error('tulasi_game_view: missing required query params (gameDomain/slug/merchantId/gameId/token)')
        return ''
      }

      const base = gameDomain.replace(/\/$/, '')
      const params = new URLSearchParams({
        merchant: merchantId,
        gameId: gameId,
        lang: lang,
        isLandscape: 'false',
        roomId: roomId,
        token: token
      })
      return `${base}/${slug}/?${params.toString()}`
    }
  }
}
</script>

<style>
.tulasi_game_view_loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/tulasi_game_view.vue